// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../usr/local/lib/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#signature .label{margin-bottom:8px}", ""]);
// Exports
module.exports = exports;
